export default __webpack_public_path__ + "media/zurb/img/home/home-service-img2-986e370baeddaeef7b42b2acee843871.png";